import Pirelli from "../../Images/Brands/pirelli.svg";
import Campagnolo from "../../Images/Brands/campagnolo.svg";
import Met from "../../Images/Brands/met.svg";
import Bont from "../../Images/Brands/Bont.png";
import Colnago from "../../Images/Brands/Colnago.png";
import Shimano from "../../Images/Brands/Shimano.png";
import Garmin from "../../Images/Brands/Garmin.png";
import Vittoria from "../../Images/Brands/Vittoria.png";
import Continental from "../../Images/Brands/Continental.png";
import Wahoo from "../../Images/Brands/wahoo.png";
import NovaRide from "../../Images/Brands/Nova Ride.png";
import Specialized from "../../Images/Brands/Specialized.png";
import Spectrum from "../../Images/Brands/Spectrum.png";
import Tactic from "../../Images/Brands/Tactic.png";
import Pinarello from "../../Images/Brands/Pinarello.png";
import Fizik from "../../Images/Brands/Fizik.png";
import Smith from "../../Images/Brands/Smith.png";
import CeramicSpeed from "../../Images/Brands/Ceramic Speed.png";
import Moon from "../../Images/Brands/Moon.png";
import Santini from "../../Images/Brands/Santini.png";
import CBear from "../../Images/Brands/C bear.png";
import Velox from "../../Images/Brands/Velox.png";
import Guee from "../../Images/Brands/Guee.png";
import Halo from "../../Images/Brands/Halo.png";
import Locallegend from "../../Images/Brands/locallegend.png";
import Adidas from "../../Images/Brands/Adidas.png";
import Babolat from "../../Images/Brands/Babolat.png";
import Bullpadel from "../../Images/Brands/Bullpadel.png";
import Head from "../../Images/Brands/Head.png";
import Nox from "../../Images/Brands/Nox.png";
import Oxdog from "../../Images/Brands/Oxdog.png";
import Pulse from "../../Images/Brands/Pulse.png";
import RoyalPadel from "../../Images/Brands/RoyalPadel.png";
import Siux from "../../Images/Brands/Siux.png";

import brandLocalLegend from "../../Videos/brandLocalLegend.mp4";
import brandComum from "../../Videos/brandComum.mp4";
import brandMet from "../../Videos/brandMet.mp4";

import image1 from "../../Images/brand-activation2.webp";
import image2 from "../../Images/brand-activation3-cropped.webp";
import image3 from "../../Images/brand-activation.webp";

const brands = [
  {
    src: Adidas,
    type: "padel",
    alt: "Adidas",
  },
  {
    src: Babolat,
    type: "padel",
    alt: "Babolat",
  },
  {
    src: Bont,
    type: "cycling",
    alt: "Bont",
  },
  {
    src: Bullpadel,
    type: "padel",
    alt: "Bullpadel",
  },
  // { src: CBear,
  // type:"cycling",alt: "CBear" },
  { src: Campagnolo, type: "cycling", alt: "Campagnolo" },
  // { src: CeramicSpeed,
  // type:"cycling",alt: "Ceramic Speed" },
  // { src: Colnago,
  // type:"cycling",alt: "Colnago" },
  // { src: Continental,
  // type:"cycling",alt: "Continental" },
  // { src: Fizik,
  // type:"cycling",alt: "Fizik" },
  // { src: Garmin,
  // type:"cycling",alt: "Garmin" },
  // { src: Guee,
  // type:"cycling",alt: "Guee" },
  { src: Halo, type: "cycling", alt: "Halo" },
  {
    src: Head,
    type: "padel",
    alt: "Head",
  },
  { src: Locallegend, type: "cycling", alt: "Local Legend" },
  {
    src: Met,
    type: "cycling",
    alt: "Met Helmet",
  },
  { src: Moon, type: "cycling", alt: "Moon" },
  // { src: NovaRide,
  // type:"cycling",alt: "Nova Ride" },
  { src: Nox, type: "padel", alt: "Nox" },
  { src: Oxdog, type: "padel", alt: "Oxdog" },
  // { src: Pinarello,
  // type:"cycling",alt: "Pinarello" },
  { src: Pirelli, type: "cycling", alt: "Pirelli" },
  { src: Pulse, type: "padel", alt: "Pulse" },
  { src: RoyalPadel, type: "padel", alt: "Royal Padel" },
  {
    src: Santini,
    type: "cycling",
    alt: "Santini",
  },
  // { src: Shimano,
  // type:"cycling",alt: "Shimano" },
  { src: Siux, type: "padel", alt: "Siux" },
  { src: Smith, type: "cycling", alt: "Smith" },
  // { src: Specialized,
  // type:"cycling",alt: "Specialized" },
  { src: Spectrum, type: "cycling", alt: "Spectrum" },
  { src: Tactic, type: "cycling", alt: "Tactic" },
  { src: Velox, type: "cycling", alt: "Velox" },
  // { src: Vittoria,
  // type:"cycling",alt: "Vittoria" },
  // { src: Wahoo,
  // type:"cycling",alt: "Wahoo" },
];

const activationVideo = [
  {
    src: brandLocalLegend,
    text: "With over 1,300 participants, Local Legend 2024 became more than a ride. It was a movement. In partnership with the Ministry of Tourism and Wonderful Indonesia, we celebrated not only the spirit of cycling, but also the vibrant culture and breathtaking landscapes of our nation. A ride that inspires, a story that lasts.",
    inverted: false,
  },
  {
    src: brandComum,
    text: "Every week, riders gather at Comum not only to ride, but to share moments, stories, and the lifestyle that makes cycling special. More than a store, Comum is your starting line for community, coffee, and premium cycling gear, all in one place.",
    inverted: true,
  },
  {
    src: brandMet,
    text: "At GWIS 2025, Met Helmet proved that protection and performance go hand in hand. As athletes raced and communities gathered, Met was there. Not just as a brand, but as a symbol of innovation and trust on every ride.",
    inverted: false,
  },
];

const brandImages = [
  { src: image1, alt: "Brand 1" },
  { src: image3, alt: "Brand 2" },
  { src: image2, alt: "Brand 3" },
];

export { brands, activationVideo, brandImages };
